export const setUser = (state, user) => {
  state.user = user
}

export const setLoading = (state, value) => {
  state.loading = value;
}